<div class="cmn-flex flex row justify-between align-center">
  <div class="cmn-flex flex row align-center">
    <mat-icon class="compact" *ngIf="data.matIconText" color="{{data.matIconColor}}">{{data.matIconText}}</mat-icon>
    <h2 class="compact" [ngClass]="{'padded-left-md' : data.matIconText}">{{ data.title }}</h2>
  </div>
  <button mat-dialog-close aria-label="Close" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <p>{{data.message}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" color="primary">{{data.cancelBtnText}}</button>
  <button mat-raised-button (click)="confirm()" color="{{data.confirmBtnColor}}">{{data.confirmBtnText}}</button>
</mat-dialog-actions>
